import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
import {
  INTERSEGURO_PALETTE,
  INTERSEGURO_SECONDARY_PALETTE,
  INTERSEGURO_INFO_PALETTE,
} from '../tokens/palette';

export const InterseguroAuraPreset = definePreset(Aura, {
  primitive: {
    interseguro:          INTERSEGURO_PALETTE,
    interseguroSecondary: INTERSEGURO_SECONDARY_PALETTE,
    interseguroInfo:      INTERSEGURO_INFO_PALETTE,
  },
  semantic: {
    primary: {
      50:  '{interseguro.50}',
      100: '{interseguro.100}',
      200: '{interseguro.200}',
      300: '{interseguro.300}',
      400: '{interseguro.400}',
      500: '{interseguro.500}',
      600: '{interseguro.600}',
      700: '{interseguro.700}',
      800: '{interseguro.800}',
      900: '{interseguro.900}',
      950: '{interseguro.950}',
    },
    secondary: {
      50:  '{interseguroSecondary.50}',
      100: '{interseguroSecondary.100}',
      200: '{interseguroSecondary.200}',
      300: '{interseguroSecondary.300}',
      400: '{interseguroSecondary.400}',
      500: '{interseguroSecondary.500}',
      600: '{interseguroSecondary.600}',
      700: '{interseguroSecondary.700}',
      800: '{interseguroSecondary.800}',
      900: '{interseguroSecondary.900}',
      950: '{interseguroSecondary.950}',
    },
    info: {
      50:  '{interseguroInfo.50}',
      100: '{interseguroInfo.100}',
      200: '{interseguroInfo.200}',
      300: '{interseguroInfo.300}',
      400: '{interseguroInfo.400}',
      500: '{interseguroInfo.500}',
      600: '{interseguroInfo.600}',
      700: '{interseguroInfo.700}',
      800: '{interseguroInfo.800}',
      900: '{interseguroInfo.900}',
      950: '{interseguroInfo.950}',
    },
    colorScheme: {
      light: {
        surface: {
          0:   '#FFFFFF',  // W
          50:  '#FAFAFA',  // G1
          100: '#F0F0F0',  // G2
          200: '#E5E5E5',  // G3
          300: '#9C9C9C',  // G4
          400: '#767676',  // GS2
          500: '#333333',  // G5
          600: '#2A2A2A',
          700: '#1A1A1A',
          800: '#111111',
          900: '#0A0A0A',
          950: '#050505',
        },
      },
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            secondary: {
              background:       '{interseguroSecondary.500}',
              hoverBackground:  '{interseguroSecondary.600}',
              activeBackground: '{interseguroSecondary.700}',
              borderColor:       '{interseguroSecondary.500}',
              hoverBorderColor:  '{interseguroSecondary.600}',
              activeBorderColor: '{interseguroSecondary.700}',
              color:       '#ffffff',
              hoverColor:  '#ffffff',
              activeColor: '#ffffff',
              focusRing: {
                color:  '{interseguroSecondary.500}',
                shadow: 'none',
              },
            },
          },
          outlined: {
            secondary: {
              hoverBackground:  '{interseguroSecondary.50}',
              activeBackground: '{interseguroSecondary.100}',
              borderColor: '{interseguroSecondary.300}',
              color:       '{interseguroSecondary.600}',
            },
          },
          text: {
            secondary: {
              hoverBackground:  '{interseguroSecondary.50}',
              activeBackground: '{interseguroSecondary.100}',
              color: '{interseguroSecondary.600}',
            },
          },
        },
        dark: {
          root: {
            secondary: {
              background:       '{interseguroSecondary.700}',
              hoverBackground:  '{interseguroSecondary.600}',
              activeBackground: '{interseguroSecondary.500}',
              borderColor:       '{interseguroSecondary.700}',
              hoverBorderColor:  '{interseguroSecondary.600}',
              activeBorderColor: '{interseguroSecondary.500}',
              color:       '#ffffff',
              hoverColor:  '#ffffff',
              activeColor: '#ffffff',
              focusRing: {
                color:  '{interseguroSecondary.500}',
                shadow: 'none',
              },
            },
          },
          outlined: {
            secondary: {
              hoverBackground:  'color-mix(in srgb, {interseguroSecondary.500}, transparent 96%)',
              activeBackground: 'color-mix(in srgb, {interseguroSecondary.500}, transparent 84%)',
              borderColor: '{interseguroSecondary.700}',
              color:       '{interseguroSecondary.400}',
            },
          },
          text: {
            secondary: {
              hoverBackground:  'color-mix(in srgb, {interseguroSecondary.500}, transparent 96%)',
              activeBackground: 'color-mix(in srgb, {interseguroSecondary.500}, transparent 84%)',
              color: '{interseguroSecondary.400}',
            },
          },
        },
      },
    },
  },
});
